/* PACK A PUNCH — VOLTAGE · interactions v1.1 (reveal, counters, particles, parallax, tilt, scrub, ship-bar) */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.pap-reveal');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Count-up stats ---------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-pap-count]');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var target = parseInt(el.getAttribute('data-pap-count'), 10);
        if (isNaN(target)) return;
        var dur = 1400, t0 = null;
        function tick(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          p = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * p);
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Hero particles ---------- */
  function initParticles() {
    var canvas = document.querySelector('[data-pap-particles]');
    if (!canvas || reduced || window.innerWidth < 750) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var colors = ['0,229,255', '182,255,46', '255,45,120'];
    var parts = [], W = 0, H = 0, running = false, raf = null;
    function resize() {
      W = canvas.offsetWidth; H = canvas.offsetHeight;
      canvas.width = W * dpr; canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spawn(init) {
      return {
        x: Math.random() * W,
        y: init ? Math.random() * H : H + 8,
        r: 0.8 + Math.random() * 1.9,
        s: 0.25 + Math.random() * 0.65,
        a: 0.12 + Math.random() * 0.4,
        c: colors[(Math.random() * colors.length) | 0],
        drift: (Math.random() - 0.5) * 0.3
      };
    }
    function loop() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y -= p.s; p.x += p.drift;
        if (p.y < -10 || p.x < -10 || p.x > W + 10) parts[i] = spawn(false);
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, 6.2832);
        ctx.fillStyle = 'rgba(' + p.c + ',' + p.a + ')';
        ctx.shadowColor = 'rgba(' + p.c + ',0.8)';
        ctx.shadowBlur = 6;
        ctx.fill();
      }
      raf = requestAnimationFrame(loop);
    }
    resize();
    var count = Math.min(70, Math.max(36, (W / 22) | 0));
    for (var i = 0; i < count; i++) parts.push(spawn(true));
    window.addEventListener('resize', resize);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !running) { running = true; loop(); }
          else if (!e.isIntersecting && running) { running = false; if (raf) cancelAnimationFrame(raf); }
        });
      }, { threshold: 0.05 }).observe(canvas);
    } else { running = true; loop(); }
  }

  /* ---------- Light parallax ---------- */
  function initParallax() {
    var els = document.querySelectorAll('[data-pap-parallax]');
    if (!els.length || reduced) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -80 || rect.top > vh + 80) return;
        var speed = parseFloat(el.getAttribute('data-pap-parallax')) || -0.05;
        var center = rect.top + rect.height / 2 - vh / 2;
        el.style.translate = '0 ' + (center * speed).toFixed(1) + 'px';
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* ---------- Pointer tilt + sheen (flavour cards) ---------- */
  function initTilt() {
    if (reduced || !window.matchMedia('(pointer: fine)').matches) return;
    var cards = document.querySelectorAll('[data-pap-tilt]');
    cards.forEach(function (card) {
      var raf = null;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.setProperty('--rx', ((0.5 - py) * 6).toFixed(2) + 'deg');
          card.style.setProperty('--ry', ((px - 0.5) * 8).toFixed(2) + 'deg');
          card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
          card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
        });
      });
      card.addEventListener('pointerleave', function () {
        if (raf) cancelAnimationFrame(raf);
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- Scroll-scrubbed energy curves ---------- */
  function initScrub() {
    if (reduced) return;
    var section = document.querySelector('.pap-problem');
    if (!section) return;
    var lines = section.querySelectorAll('.pap-curve__line');
    if (!lines.length) return;
    var LEN = 620, ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      var r = section.getBoundingClientRect();
      if (r.bottom < -40 || r.top > vh + 40) return;
      var p = (vh * 0.92 - r.top) / (vh * 0.7);
      p = Math.max(0, Math.min(1, p));
      for (var i = 0; i < lines.length; i++) {
        lines[i].style.transition = 'none';
        lines[i].style.strokeDashoffset = (LEN * (1 - p)).toFixed(1);
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Free-shipping progress (cart drawer) ---------- */
  function initShipBar() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.fetch) return;
    var THRESHOLD = 10000; /* cents — 100 AUD free-shipping threshold */
    var busy = false, timer = null;
    var style = document.createElement('style');
    style.textContent = '.pap-ship{margin:1.2rem 0 .4rem;padding:1.2rem 1.4rem;border:1px solid rgba(255,255,255,.1);border-radius:1.2rem;background:rgba(255,255,255,.03);font-size:1.25rem}.pap-ship__row{display:flex;justify-content:space-between;gap:1rem;margin-bottom:.8rem}.pap-ship__label{color:rgba(207,222,233,.78)}.pap-ship__label strong{color:#F2F6FA}.pap-ship__done{color:#B6FF2E;font-weight:700}.pap-ship__track{display:block;height:.6rem;border-radius:99px;background:rgba(255,255,255,.08);overflow:hidden}.pap-ship__fill{display:block;height:100%;border-radius:99px;background:linear-gradient(90deg,#00E5FF,#B6FF2E);box-shadow:0 0 12px rgba(0,229,255,.5);transition:width .5s cubic-bezier(.16,1,.3,1)}';
    document.head.appendChild(style);
    function money(cents) { return '$' + (cents / 100).toFixed(2); }
    function render(total) {
      busy = true;
      var el = drawer.querySelector('.pap-ship');
      if (drawer.classList.contains('is-empty')) {
        if (el) el.remove();
        busy = false;
        return;
      }
      if (!el) {
        el = document.createElement('div');
        el.className = 'pap-ship';
        var header = drawer.querySelector('.drawer__header');
        if (header && header.parentNode) header.parentNode.insertBefore(el, header.nextSibling);
        else {
          var inner = drawer.querySelector('.drawer__inner');
          if (inner) inner.prepend(el); else { busy = false; return; }
        }
      }
      var remaining = THRESHOLD - total;
      var pct = Math.max(4, Math.min(100, Math.round(total / THRESHOLD * 100)));
      el.innerHTML = remaining > 0
        ? '<div class="pap-ship__row"><span class="pap-ship__label">You’re <strong>' + money(remaining) + '</strong> from free AU shipping</span><span class="pap-ship__label">' + pct + '%</span></div><span class="pap-ship__track"><span class="pap-ship__fill" style="width:' + pct + '%"></span></span>'
        : '<div class="pap-ship__row"><span class="pap-ship__done">⚡ Free AU shipping unlocked</span></div><span class="pap-ship__track"><span class="pap-ship__fill" style="width:100%"></span></span>';
      requestAnimationFrame(function () { busy = false; });
    }
    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c.total_price || 0); })
        .catch(function () {});
    }
    new MutationObserver(function () {
      if (busy) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (drawer.classList.contains('active')) refresh();
      }, 160);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }

  function boot() { initReveal(); initCounters(); initParticles(); initParallax(); initTilt(); initScrub(); initShipBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { initReveal(); initTilt(); });
})();
